import { Component, OnInit } from '@angular/core';
import { CommonPermissionService } from "src/app/shared/services/common-permission.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import {CommonService} from '../../shared/services/common.service';
import {AsignUserRoleService} from '../../shared/services/asign-user-role.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OneSignal } from 'onesignal-ngx';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  permissions: any = [];
  permissionsParentChild: any = [];

  backgroundColorHomePage = "";

  private oneSignalListenerAdded = false;

  constructor(
  private commonPermissionService: CommonPermissionService,
  private spinner: NgxUiLoaderService,
  private sanitizer: DomSanitizer,
  private localStorageSettings: LocalStorageSettingsService,
  private commonService: CommonService,
  private OneSignal: OneSignal,
  private asignUserRoleService: AsignUserRoleService,
  private snackbar: MatSnackBar
) {
  this.initOneSignal();
}

async initOneSignal() {
  try {
    await this.OneSignal.init({
      appId: environment.oneSignalAppId,
      serviceWorkerPath: 'OneSignalSDKWorker.js'
    });

    this.registerOneSignalSubscriptionChange();

    const currentId = this.OneSignal.User.PushSubscription.id;
    console.log( this.OneSignal.User);
    if (currentId == undefined) {
      this.insertOneSignalUser(currentId);
    }

  } catch (error) {
    console.log(error);
  }
}
  
registerOneSignalSubscriptionChange() {
  if (this.oneSignalListenerAdded) {
    return;
  }

  this.oneSignalListenerAdded = true;
      this.OneSignal.User.PushSubscription.addEventListener('change', (eventDetails: any) => {
    console.log(eventDetails);

    const oneSignalId = eventDetails?.current?.id;

    if (oneSignalId) {
      this.insertOneSignalUser(oneSignalId);
    }
  });
  
}

insertOneSignalUser(onesignalId: string) {
  if (!onesignalId) return;

  const oneSignal = {
    oneSignalPlayersId: onesignalId,
    userId: this.localStorageSettings.getSettings('UserId'),
    username: this.localStorageSettings.getSettings('AuthUsername'),
  };

  this.commonService.insertOneSignalUser(oneSignal).subscribe(res => {
    console.log(res);
  });
}

  async ngOnInit() {
    var userName = localStorage.getItem("AuthUsername");

    console.log(userName);

    let userData: any = await this.commonService.retrieveSingleRecordService("users", "username", userName);

    console.log(userData);

    let userId = userData[0].userid;

    console.log("userId");

    console.log(userId);
    //reterive user Role By Tenant Id And UserId
    this.asignUserRoleService.reteriveuserRoleByTenantIdAndUserId(userId).subscribe(response => {

      console.log("roletype")
      if (response.error === true) {

        console.log(response);

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, "OK", {duration: 5000});

      } else {
        this.getHomeData(response);

      }

    })


    this.backgroundColorHomePage = this.localStorageSettings.getSettings("ColorD");

  }
  getHomeData(userId) {
    this.spinner.start();
    this.commonPermissionService.retrieveWeb(userId).subscribe(response => {
      console.log(response);
      var permissionsLength = response[0];
      this.permissions = response[1];
      console.log(this.permissions);
      //In children array inside arrays are created four json objects are storing into one array.
      var permissionMain=[]
      for (var i = 0; i < this.permissions.length; i++) {
        //It will execute if child length is greater then zero

        if (this.permissions[i].child.length > 0) {
          console.log(this.permissions[i].child);
          //Storing child into childrenTemp
          var childrenTemp = this.permissions[i].child;
          console.log(childrenTemp);
          //Clearning the child
          this.permissions[i].child = [];
          console.log(this.permissions[i].child);
          var childrenObj = [];
          var childrenAnother = [];
          var k = -1;
          for (var j = 0; j < childrenTemp.length; j++) {
            k = k + 1;
            childrenObj.push(childrenTemp[j]);
            //It is changed by nikhil 11-12-2019
            //Changed the value from 3 to 5
            while (k == 5) {
              //Four json objects storing into one array
              childrenAnother.push(childrenObj);
              k = -1;
              childrenObj = [];
            }
          }
          childrenAnother.push(childrenObj);
          this.permissions[i].child = childrenAnother;
          permissionMain.push(this.permissions[i])
        }

      }

      this.permissionsParentChild = permissionMain;
      console.log(this.permissionsParentChild)
      this.spinner.stop()
    });

  }

  getSanitizer(keyValue) {

    return this.sanitizer.bypassSecurityTrustUrl(keyValue);

  }

}
